import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';

import Stack from '@mui/material/Stack';
import ListSubheader from '@mui/material/ListSubheader';

import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionVertical({ data, slotProps, ...other }) {
  return (
    <Stack component="nav" id="nav-section-vertical" {...other}>
      {data.map((group, index) => (
        <Group
          key={group.subheader || index}
          subheader={group.subheader}
          items={group.items}
          slotProps={slotProps}
          groupRoles={group.groupRoles}
        />
      ))}
    </Stack>
  );
}

NavSectionVertical.propTypes = {
  data: PropTypes.array.isRequired,
  slotProps: PropTypes.object.isRequired
}

export default memo(NavSectionVertical);

// ----------------------------------------------------------------------

function Group({ subheader, items, slotProps, groupRoles }) {
  //  const [open, setOpen] = useState(true);
  //  const handleToggle = useCallback(() => {
  //   setOpen((prev) => !prev);
  // }, []);
  const shouldRenderGroup = useCallback(() => {
    if (!groupRoles) return true;

    return groupRoles.includes(slotProps?.currentRole);
  }, [groupRoles, slotProps?.currentRole]);

  const renderContent = items.map((list) => (
    <NavList key={list.title} data={list} depth={1} slotProps={slotProps} />
  ));
  if (!shouldRenderGroup()) {
    return null;
  }

  return (
    <Stack sx={{ mb: 2 }}>
      {subheader ? (
        <>
          <ListSubheader
            disableGutters
            disableSticky
            //  onClick={handleToggle}
            sx={{
              fontSize: 11,
              cursor: 'pointer',
              typography: 'overline',
              display: 'inline-flex',
              color: 'text.disabled',
              mb: 0,
              p: (theme) => theme.spacing(2, 1, 1, 1.5),
              transition: (theme) =>
                theme.transitions.create(['color'], {
                  duration: theme.transitions.duration.shortest,
                }),
              '&:hover': {
                color: 'text.primary',
              },
              ...slotProps?.subheader,
            }}
          >
            {subheader}
          </ListSubheader>

          {/* <Collapse in={open}></Collapse> */}
          {renderContent}
        </>
      ) : (
        renderContent
      )}
    </Stack>
  );
}

Group.propTypes = {
  groupRoles: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  slotProps: PropTypes.object.isRequired,
  subheader: PropTypes.string.isRequired
}
